export const gitCommit = '49c478a2'
